import SiteNav from '@/components/organisms/SiteNav'
import IndustryPickerSection from '@/components/organisms/IndustryPickerSection'
import FooterStub from '@/components/organisms/FooterStub'
import Hero from './components/Hero'
import ProductsSection from './components/ProductsSection'

export function HomePage() {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />
                <Hero />
                <ProductsSection />
                <IndustryPickerSection />
                <FooterStub />
            </div>

        </div>
    )
}

export default HomePage
